module.exports = __webpack_public_path__ + "img/Face.e41b9179.svg";